  <template>
  <row>
    <column class="col-lg-3">
      <va-box title="Report Designer" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <h5>Report Name:</h5>
          <Container group-name="Header" style="padding: 10px; border-bottom: 1px solid #f4f4f4;">
            <input type="text" v-model="report.Name" style="width: 100%; padding: 5px;" />
          </Container>

          <h5>Orientation:</h5>
          <Container group-name="Header" style="padding: 10px; border-bottom: 1px solid #f4f4f4;">
            <div v-for="item in orientationItems" class="tree-content tree--small" @click="orientation=item.name">
              <i :class="['tree-checkbox', orientation===item.name?'checked':'']"></i>
              <span tabindex="-1" class="tree-anchor">
                <i :class="[item.icon, item.class]"></i>&nbsp;&nbsp; {{item.name}}
              </span>
            </div>
          </Container>

          <h5 v-if="0>1">{{'Margins (' + marginsPx + ' inches):'}}</h5>
          <Container v-if="0>1" group-name="Header" style="padding: 10px; border-bottom: 1px solid #f4f4f4;">
            <input type="range" min="0" max="1" step="0.1" v-model="marginsPx">
          </Container>

          <h5>Items:</h5>
          <div group-name="Header" style="padding: 10px; border-bottom: 1px solid #f4f4f4;">
            <div v-for="(item, index) in controlItems"
                 @dragstart="dragStart(item, $event)"
                 draggable="true"
                 class="draggable-component">
              <i :class="item.icon"></i> {{item.name}}
            </div>
          </div>
          <h5>Filters:</h5>
          <Container group-name="Header" style="padding: 10px;">
            <div class="tree-content tree--small" @click="report.Filters.FromDate=!report.Filters.FromDate">
              <i :class="['tree-checkbox', report.Filters.FromDate?'checked':'']"></i>&nbsp;&nbsp;From Date
            </div>
            <div class="tree-content tree--small" @click="report.Filters.ToDate=!report.Filters.ToDate">
              <i :class="['tree-checkbox', report.Filters.ToDate?'checked':'']"></i>&nbsp;&nbsp;To Date
            </div>
            <div class="tree-content tree--small" @click="report.Filters.Monthly=!report.Filters.Monthly">
              <i :class="['tree-checkbox', report.Filters.Monthly?'checked':'']"></i>&nbsp;&nbsp;Monthly
            </div>
            <div class="tree-content tree--small" @click="report.Filters.DealerKey=!report.Filters.DealerKey">
              <i :class="['tree-checkbox', report.Filters.DealerKey?'checked':'']"></i>&nbsp;&nbsp;Dealer
            </div>
            <div class="tree-content tree--small" @click="report.Filters.CustomerKey=!report.Filters.CustomerKey">
              <i :class="['tree-checkbox', report.Filters.CustomerKey?'checked':'']"></i>&nbsp;&nbsp;Customer
            </div>
            <div class="tree-content tree--small" @click="report.Filters.SiteKey=!report.Filters.SiteKey">
              <i :class="['tree-checkbox', report.Filters.SiteKey?'checked':'']"></i>&nbsp;&nbsp;Site
            </div>
            <div class="tree-content tree--small" @click="report.Filters.PrinterKey=!report.Filters.PrinterKey">
              <i :class="['tree-checkbox', report.Filters.PrinterKey?'checked':'']"></i>&nbsp;&nbsp;Printer
            </div>
          </Container>

          <!--<Container group-name="Report" behaviour="copy" :get-child-payload="getReportPayload">
    <Draggable class="draggable-component" v-for="item in controlItems">
      <div>
        <i :class="item.icon"></i> {{item.name}}
      </div>
    </Draggable>
  </Container>-->
        </div>
        <div slot="footer">
          <div class="box-header">
            <div class="pull-right">
              <input type="button" class="btn btn-success btn-small" value="Save" style="width: 100px;" />
              <input type="button" class="btn btn-danger" value="Cancel" style="width: 100px;" />
            </div>
          </div>
        </div>
      </va-box>
    </column>
    <column class="col-lg-9" style="background-color: #525659; padding: 20px;">
      <div :style="reportCss" class="reportPage">
        <ReportPage v-if="report" :orientation="orientation" :reportDef="report.Definition"></ReportPage>
      </div>
    </column>
    <div class="statusBar">
      <row>
        <column class="col-lg-2" style="border-right: 1px solid #bbb;">
          <b>{{$root.shortText(report.Name, 40)}}</b>
        </column>
        <column class="col-lg-10">
          <column class="col-lg-6" style="border-right: 1px solid #bbb;">Abed</column>
          <column class="col-lg-6">
            <column class="col-lg-3" style="border-right: 1px solid #bbb;">
              <b>{{$root.shortText(activeElement.name, 20)}}</b>
            </column>
            <column class="col-lg-4">
              <column class="col-lg-2">X:</column>
              <column class="col-lg-4"><b>{{activeElement.x}}</b></column>
              <column class="col-lg-2">Y:</column>
              <column class="col-lg-3"><b>{{activeElement.y}}</b></column>
            </column>
            <column class="col-lg-5">
              <column class="col-lg-3">Width:</column>
              <column class="col-lg-3"><b>{{activeElement.w}}</b></column>
              <column class="col-lg-3">Height:</column>
              <column class="col-lg-3"><b>{{activeElement.h}}</b></column>
            </column>
          </column>
        </column>
      </row>
    </div>
  </row>
</template>
<script>
  //  * * * TODO:
  //  * * * Check fast-report web designer
  // https://www.fast-report.com:2015/razor/Home/Designer
  // ====================================================

  import { Container, Draggable } from 'vue-smooth-dnd'
  import VATab from '../components/VACustomTab'
  import ReportGrid from '../components/ReportGrid'
  import reportDef from '../reports/data/charts-report-def.json'
  import timeData from '../reports/data/time-data.json'
  import timeDataSchema from '../reports/data/time-data-schema.json'
  import { db } from '../firebase'
  import VABox from '../components/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import SettingsDealer from '../components/SettingsDealer'
  import ReportBasic from '../reports/ReportBasic'
  import ReportCharts from '../reports/ReportCharts'
  import ReportPage from '../components/ReportDesign/ReportPage'
  import RulerX from '../components/ReportDesign/RulerX'
  export default {
    name: 'ReportDesigner',
    components: {
      VATab,
      ReportPage,
      RulerX,
      Container,
      Draggable,
      ReportGrid,
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      SettingsDealer,
      ReportBasic,
      ReportCharts
    },
    data () {
      return {
        activeTab: '',
        dataItems: [
          { fieldName: 'Status', label: 'Status' },
          { fieldName: 'Logged', label: 'Date' },
          { fieldName: 'MacAddress', label: 'MAC Address' },
          { fieldName: 'PrinterSerial', label: 'Serial' },
          { fieldName: 'ModelName', label: 'Model' },
          { fieldName: 'IPAddress', label: 'IP Address' },
          { fieldName: 'PageCount', label: 'Pages' },
          { fieldName: 'HostName', label: 'Host' },
          { fieldName: 'Location', label: 'Location' },
          { fieldName: 'Dealer', label: 'Dealer' },
          { fieldName: 'Customer', label: 'Customer' },
          { fieldName: 'Site', label: 'Site' },
          { fieldName: 'ErrorString', label: 'Error' },
          { fieldName: 'A4Black', label: 'A4 Black' },
          { fieldName: 'A4Color', label: 'A4 Color' },
          { fieldName: 'A3Black', label: 'A3 Black' },
          { fieldName: 'A3Color', label: 'A3 Color' },
          { fieldName: 'Copy', label: 'Copy' },
          { fieldName: 'Scan', label: 'Scan' },
          { fieldName: 'Duplex', label: 'Duplex' },
          { fieldName: 'Fax', label: 'Fax' },
          { fieldName: 'BlackTonerLeft', label: 'Black' },
          { fieldName: 'CyanTonerLeft', label: 'Cyan' },
          { fieldName: 'MagentaTonerLeft', label: 'Magenta' },
          { fieldName: 'YellowTonerLeft', label: 'Yellow' }
        ],
        activeItem: '',
        reportCss: {
          position: 'relative',
          // backgroundColor: '#fff',
          backgroundColor: '#ddd',
          width: '8.5in',
          height: '11in',
          marginLeft: 'auto',
          marginRight: 'auto'
        },
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        marginsPx: 5,
        orientation: 'Portrait',
        orientationItems: [
          { name: 'Portrait', icon: 'fa fa-file-pdf-o' },
          { name: 'Landscape', icon: 'fa fa-file-pdf-o', class: 'rotate-flip' }
        ],
        controlItems: [
          { name: 'Date', icon: 'fa fa-calendar', dropOn: 'Header' },
          // { name: 'Image', icon: 'fa fa-image', dropOn: 'All' },
          // { name: 'Title', icon: 'fa fa-header', dropOn: 'Header' },
          { name: 'Label', icon: 'fa fa-tag', dropOn: 'All' },
          { name: 'Data Item', icon: 'fa fa-database', dropOn: 'Body' },
          // { name: 'Checkbox', icon: 'fa fa-check', dropOn: 'Body' },
          { name: 'Page Number', icon: 'fa fa-sort-numeric-asc', dropOn: 'Footer' },
          { name: 'Pages Count', icon: 'fa fa-sort-numeric-asc', dropOn: 'Footer' },
          { name: 'Copyrights', icon: 'fa fa-copyright', dropOn: 'Footer' }
          // { name: 'Contacts Information', icon: 'fa fa-inbox', dropOn: 'All' }
        ],
        reportItems: [],
        report: {
          Name: 'New Report',
          Method: '',
          OrderIndex: 0,
          Filters: {
            DealerKey: true,
            CustomerKey: true,
            SiteKey: true,
            PrinterKey: true,
            FromDate: true,
            ToDate: true,
            Monthly: true
          }
        },
        reportOLD: {
          data: null,
          dataSchema: null,
          dataDef: null,
          dataSource: null
        },
        activeElement: {
          name: '',
          x: 0,
          y: 0,
          w: 0,
          h: 0
        }
      }
    },
    created () {
      this.$root.title = 'ReportDesigner'
      if (!document.body.classList.contains('sidebar-collapse')) {
        let btnSidebarToggle = document.getElementById('btnSidebarToggle')
        if (btnSidebarToggle) {
          btnSidebarToggle.click()
        }
      }
    },
    mounted () {
      var vm = this
      vm.loadReport()
      /*
      if (vm.$route.params.reportKey && vm.$route.params.reportKey !== 'NA') {
        vm.loadReport()
      } else {
        vm.resetReport()
      }
      */
      if (vm.report) {
        vm.report.data = timeData
        vm.report.dataSchema = timeDataSchema
        vm.report.dataDef = reportDef
        vm.report.dataSource = [{
          id: 'time',
          name: 'Time',
          data: vm.report.data,
          schema: vm.report.dataSchema
        }]
      }
      /*
      var dataSource = [{
        id: 'time',
        name: 'Time',
        data: this.report.data,
        schema: this.report.dataSchema
      }]
      /*
      var designer = new jsreports.Designer({
        embedded: true,
        container: $('.report-designer-container'),
        data_sources: vm.report.dataSource,
        report_def: vm.report.dataDef,
        layout: 'horizontal'
      })
      */
      // console.log(designer)
      this.$bus.$on('activeElement', (args) => {
        this.activedElement(args)
      })
    },
    watch: {
      marginsPx (val) {
        console.log('ReportDesigner marginsPx = ' + val)
        console.log('ReportDesigner this.report.Definition.page.margins.top = ' + this.report.Definition.page.margins.top)
        if (val !== this.report.Definition.page.margins.top) {
          this.report.Definition.page.margins.top = val
          this.report.Definition.page.margins.right = val
          this.report.Definition.page.margins.bottom = val
          this.report.Definition.page.margins.left = val
        }
      },
      orientation (val) {
        console.log('ReportDesigner orientation = ' + val)
        switch (val) {
          case 'Portrait':
            this.reportCss.width = '8.5in'
            this.reportCss.height = '11in'
            this.report.Definition.page.paper_size.inches[0] = 8.5
            this.report.Definition.page.paper_size.inches[1] = 11
            break
          case 'Landscape':
            this.reportCss.width = '11in'
            this.reportCss.height = '8.5in'
            this.report.Definition.page.paper_size.inches[0] = 11
            this.report.Definition.page.paper_size.inches[1] = 8.5
            break
        }
        this.$forceUpdate()
      }
    },
    methods: {
      dragStart (item, event) {
        if (event.dataTransfer) {
          console.log('item : ')
          console.log(item)
          console.log(event)
          console.log(event.target)
          item.handlePos = {
            x: event.offsetX,
            y: event.offsetY
          }
          event.dataTransfer.setData('Data', JSON.stringify(item))
          // event.dataTransfer.setData('Text', event.target.index)
          // event.dataTransfer.setData('Text', event.target.id)
        } else {
          console.log('dragStart has no data !!')
        }
      },
      deActivateElements () {
        console.log('deActivateElements() ... ')
        this.$bus.$emit('activeElement', null)
      },
      activedElement (elm) {
        if (elm) {
          this.activeElement = {
            name: elm.text,
            x: elm.left.toFixed(4),
            y: elm.top.toFixed(4),
            w: elm.width.toFixed(4),
            h: elm.height.toFixed(4)
          }
        } else {
          this.activeElement = {
            name: '',
            x: 0,
            y: 0,
            w: 0,
            h: 0
          }
        }
      },
      addDataTable () {
        console.log(JSON.stringify(this.report.Definition.header.elements))
        console.log(JSON.stringify(this.report.Definition.body.elements))
        let pageHeaderElements = []
        let bodyElements = []

        let fixedWidth = 1
        let fixedHeight = 0.25
        let headerTop = 0.1
        let bodyTop = headerTop + fixedHeight
        pageHeaderElements = []
        for (let i = 0; i < this.dataItems.length; i++) {
          let dataItem = this.dataItems[i]
          let leftPos = fixedWidth * i
          pageHeaderElements.push({
            text: dataItem.label,
            type: 'text',
            top: headerTop,
            left: leftPos,
            width: fixedWidth,
            height: fixedHeight,
            bold: true,
            align: 'right'
          })
          bodyElements.push({
            text: '[' + dataItem.fieldName + ']',
            type: 'text',
            top: bodyTop,
            left: leftPos,
            width: fixedWidth,
            height: fixedHeight,
            bold: false,
            align: 'right'
          })
        }
        this.report.Definition.page_header.elements = pageHeaderElements
        this.report.Definition.body.elements = bodyElements
        // this.report.Definition.body.elements
        // this.report.Definition.page_header = { height: 1, visible: true, elements: [] }
        // this.report.Definition.page_footer
      },
      boxBodyClicked (isVisible) {
        console.log('boxBodyClicked(isVisible) = ' + isVisible)
        this.report.Definition.body.visible = isVisible
      },
      boxHeaderClicked (isVisible) {
        console.log('boxHeaderClicked(isVisible) = ' + isVisible)
        this.report.Definition.header.visible = isVisible
      },
      boxFooterClicked (isVisible) {
        console.log('boxFooterClicked(isVisible) = ' + isVisible)
        this.report.Definition.footer.visible = isVisible
      },
      resize (newRect) {
        if (newRect.width > 500) { newRect.width = 500 }
        this.width = newRect.width
        this.height = newRect.height
        this.top = newRect.top
        this.left = newRect.left
      },
      getReportPayload (index) {
        return this.controlItems[index]
      },
      removeReportItem (index) {
        this.reportItems.splice(index, 1)
      },
      onDrop (collection, dropResult) {
        this[collection] = this.applyDrag(this[collection], dropResult)
      },
      applyDrag (arr, dragResult) {
        const { removedIndex, addedIndex, payload } = dragResult
        console.log('removedIndex = ' + removedIndex)
        console.log('addedIndex = ' + addedIndex)
        if (removedIndex === null && addedIndex === null) return arr
        const result = [...arr]
        let itemToAdd = payload
        itemToAdd.guid = this.$moment().format('YYYYMMDDHHmmss')
        if (removedIndex !== null) {
          itemToAdd = result.splice(removedIndex, 1)[0]
        }
        if (addedIndex !== null) {
          result.splice(addedIndex, 0, itemToAdd)
        }
        return result
      },
      loadReport () {
        var vm = this
        let reportKey = vm.$route.params.reportKey
        // reportKey = 'demo'
        db.ref('Reports/' + reportKey).once('value', (snapReport) => {
          vm.printers = []
          let reportData = snapReport.val()
          if (reportData) {
            console.log(reportData)
            vm.report = reportData
            if (vm.report) {
              console.log('vm.report = ' + JSON.stringify(vm.report))
              if (vm.report && !vm.report.Definition.filters) {
                vm.report.Definition.filters = []
              }
              if (vm.report && !vm.report.Definition.inputs) {
                vm.report.Definition.inputs = []
              }
              vm.marginsPx = vm.report.Definition.page.margins.top
              vm.orientation = (Number(vm.report.Definition.page.paper_size.inches[0]) < Number(vm.report.Definition.page.paper_size.inches[1])) ? 'Portrait' : 'Landscape'
              let dataSource = [{
                id: 'report',
                data: reportData
              }]
              try {
                jsreports.render({
                  report_def: vm.report.Definition,
                  target: $('.report-output'),
                  datasets: dataSource
                })
              } catch (e) {
                console.log(e)
              }
              /*
              jsreports.export({
                format: 'pdf',
                report_def: vm.report.Definition,
                datasets: dataSource,
                outputHandler: function (pdfBlob) {
                  vm.reportPDF = URL.createObjectURL(pdfBlob)
                  $('.report-output').attr('src', URL.createObjectURL(pdfBlob))
                  vm.isLoading = false
                  vm.hasData = true
                }
              })
              */
            }
          } else {
            vm.resetReport()
          }
        })
      },
      resetReport () {
        var vm = this
        vm.report = {}
        vm.report.Name = 'New Report'
        vm.report.Method = ''
        vm.report.OrderIndex = 0
        vm.report.Filters = {
          DealerKey: true,
          CustomerKey: true,
          SiteKey: true,
          PrinterKey: true,
          FromDate: true,
          ToDate: true,
          Monthly: true
        }
        vm.report.Definition = {
          default_format: 'html',
          id: 'newReport',
          type: 'hierarchical',
          version: '1.2.20',
          title: 'New Report (no title)',
          filters: [],
          inputs: [],
          header: {
            height: 1,
            left: 0,
            top: 0,
            visible: true,
            width: 7.5,
            elements: [{
              background_color: '#efefef',
              border_color: '#ffffff',
              corner_radius: 0,
              fontsize: 16,
              height: 0.7,
              left: 0,
              styles: 'title',
              text: '',
              top: 0.1,
              type: 'box',
              width: 7.5,
              wrap: true
            },
            {
              bold: true,
              left: 0,
              top: 0.1,
              width: 3,
              height: 0.5,
              fontsize: 16,
              styles: 'title',
              text: vm.report.Name,
              type: 'text',
              wrap: true
            },
            {
              bold: true,
              left: 6.5,
              top: 0.1,
              width: 1,
              height: 0.5,
              fontsize: 16,
              styles: 'title',
              text: '[Date]',
              type: 'text',
              wrap: true
            }]
          },
          footer: {
            height: 1,
            left: 0,
            top: 9,
            visible: true,
            width: 7.5,
            elements: []
          },
          page: {
            margins: {
              bottom: 0.5,
              left: 0.5,
              right: 0.5,
              top: 0.5
            },
            paper_size: {
              id: 'letter',
              inches: [8.5, 11],
              mm: [216, 279],
              name: 'Letter'
            },
            units: 'inches'
          },
          page_header: {
            height: 1,
            visible: true,
            elements: []
          },
          page_footer: {
            height: 1,
            visible: true,
            elements: [{
              bold: true,
              align: 'right',
              fontsize: '10',
              left: 5,
              top: 0.2,
              width: 2.5,
              height: 0.5,
              text: 'page [PAGE_NUMBER] of [PAGE_COUNT]',
              type: 'text'
            }]
          },
          body: {
            column_count: 1,
            data_source: 'report',
            height: 7.85,
            left: 0,
            top: 1.15,
            visible: true,
            width: 7.5,
            show_detail: true,
            elements: []
          }
        }
      }
    }
  }
</script>
<style>
  .itemTmp {
    width: 50px;
    height: 50px;
    border: 1px solid black;
    background: gray;
    position: absolute;
    top: 0;
    left: 0;
  }
  .reportPage {
    background: linear-gradient(90deg, #fff 20px, transparent 1%) center, linear-gradient(#fff 20px, transparent 1%) center, #ccc;
    background: linear-gradient(90deg, #fff 10px, transparent 1%) center, linear-gradient(#fff 10px, transparent 1%) center, #ccc;
    background-size: 22px 22px;
    background-size: 11px 11px;
  }
  .page {
    width: 210mm !important;
    min-height: 297mm !important;
    margin: 10mm auto;
  }
  .subpage {
    padding: 0.5cm;
    border: 1px #bbb dotted;
    height: 257mm !important;
    /*outline: 2cm #eee solid;*/
    background: linear-gradient(90deg, #fff 20px, transparent 1%) center, linear-gradient(#fff 20px, transparent 1%) center, #ccc;
    background-size: 22px 22px;
    overflow: hidden;
  }
  .sectionTitle {
    color: #777;
    font-style: italic;
    border-bottom: 1px #ccc dashed;
    width: 200mm !important;
  }
  .pageHeader {
    height: 50mm !important;
    background-color: #bbb;
  }
  .pageBody {
    height: 150mm !important;
    background-color: #ccc;
  }
  .pageFooter {
    height: 50mm !important;
    background-color: #aaa;
  }
  .removeItem {
    float: right;
    color: #555;
    cursor: pointer;
    visibility: hidden;
  }
  .draggable-item:hover .removeItem {
    visibility: visible;
  }
  .smooth-dnd-container {
    width: 100%;
    height: 100%;
  }
  .draggable-item {
    height: 50px;
    line-height: 50px;
    text-align: center;
    display: block;
    background-color: #fff;
    outline: 0;
    border: 1px solid rgba(0, 0, 0, .125);
    margin-bottom: 2px;
    margin-top: 2px;
    cursor: default;
    user-select: none;
  }
  .draggable-component {
    height: 30px;
    line-height: 30px;
    display: block;
    background-color: #fff;
    outline: 0;
    border: 1px solid rgba(0, 0, 0, .125);
    margin-bottom: 1px;
    margin-top: 1px;
    padding-left: 10px;
    cursor: pointer;
    user-select: none;
  }
  .rotate-flip {
    -webkit-transform: rotate(-90deg) scale(1, -1);
    -moz-transform: rotate(-90deg) scale(1, -1);
    -o-transform: rotate(-90deg) scale(1, -1);
    -ms-transform: rotate(-90deg) scale(1, -1);
    transform: rotate(-90deg) scale(1, -1);
  }
  .statusBar{
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 25px;
    background-color: #ddd;
    color: #777;
    border: 1px solid #bbb;
    line-height: 25px;
    font-size: 12px;
    padding: 0px 10px;
  }
  ul.nav > li > a {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  ul.nav > li.active > a {
    border-bottom: none;
  }
</style>




// WEBPACK FOOTER //
// ReportDesigner.vue?0f426edf